import Button from "@restart/ui/esm/Button";
import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import Alert from "../../components/alert/Alert";
import { setAlert } from "../../store/actions/alertActions";
import { nomineeDecrypt } from "../../store/actions/dashboardActions";
import "./Nominee.css";

function Nominee({ match, setAlert, alerts, nomineeDecrypt, dashboard }) {
  const [key, setKey] = useState("");
  const [hasId, setHasId] = useState(!!match.params.userId);
  const [userId, setUserId] = useState(match.params.userId);

  const onKeyChange = (e) => {
    setKey(e.target.value);
  };

  const onIdChange = (event) => {
    setUserId(event.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!userId || !key) {
      setAlert("Please fill out all shown fields!", 3, "error");
      return;
    }

    nomineeDecrypt(userId, key);
  };

  if (!dashboard.loading && dashboard.success) {
    return (
      <div className="nominee">
        <h4>Secret Note</h4>
        <br />
        <Form className="note-form">
          <Form.Control
            className="note-box"
            value={dashboard.text}
            as="textarea"
            name="note"
            disabled
          />
        </Form>
      </div>
    );
  }

  return (
    <div className="nominee">
      <Alert alerts={alerts} />
      <h3 className="title">Nominee Login</h3>
      <br />
      <br />
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Enter User Id
        </Form.Label>
        <Col sm="10">
          <Form.Control
            defaultValue={userId}
            disabled={hasId ? true : false}
            value={userId}
            onChange={onIdChange}
            required
          />
        </Col>
      </Form.Group>

      <br />
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Enter Secret Key
        </Form.Label>
        <Col sm="10">
          <Form.Control value={key} onChange={onKeyChange} required />
        </Col>
      </Form.Group>

      <br />
      <Button onClick={onSubmit} className="save-btn" type="submit">
        Submit
      </Button>
    </div>
  );
}

const mapStateToProps = (state) => ({
  alerts: state.alert,
  dashboard: state.dashboard,
});

export default connect(mapStateToProps, { setAlert, nomineeDecrypt })(Nominee);
